const ROOT_SELECTOR = '.jp-hero-shell';
const SLIDE_SELECTOR = 'slideshow-slide.jp-hero__slide[data-jp-nav-label]';
const TAB_SELECTOR = '.jp-hero__tab[data-jp-nav-index]';

function getShells(scope = document) {
  const shells = [];

  if (scope instanceof Element) {
    if (scope.matches(ROOT_SELECTOR)) {
      shells.push(scope);
    }

    const closestShell = scope.closest(ROOT_SELECTOR);
    if (closestShell && !shells.includes(closestShell)) {
      shells.push(closestShell);
    }
  }

  if ('querySelectorAll' in scope) {
    for (const shell of scope.querySelectorAll(ROOT_SELECTOR)) {
      if (!shells.includes(shell)) {
        shells.push(shell);
      }
    }
  }

  return shells;
}

function syncShell(shell) {
  const slideshow = shell.querySelector('slideshow-component');
  if (!slideshow) return;

  const slides = [...slideshow.querySelectorAll(SLIDE_SELECTOR)];
  const tabs = [...slideshow.querySelectorAll(TAB_SELECTOR)];

  if (!slides.length || !tabs.length) return;

  for (const slide of slides) {
    const rawIndex = slide.getAttribute('data-jp-nav-index');
    const index = Number.parseInt(rawIndex ?? '', 10);

    if (!Number.isInteger(index) || index < 0) continue;

    const tab = tabs.find(
      (candidate) =>
        Number.parseInt(candidate.getAttribute('data-jp-nav-index') ?? '', 10) === index
    );

    if (!tab) continue;

    const fallback = `Slide ${index + 1}`;
    const label = (slide.getAttribute('data-jp-nav-label') || '').trim() || fallback;

    const text = tab.querySelector('[data-jp-nav-text]');
    if (text && text.textContent?.trim() !== label) {
      text.textContent = label;
    }

    const ariaLabel = `Show ${label}`;
    if (tab.getAttribute('aria-label') !== ariaLabel) {
      tab.setAttribute('aria-label', ariaLabel);
    }
  }
}

function sync(scope = document) {
  for (const shell of getShells(scope)) {
    syncShell(shell);
  }
}

let scheduled = false;

function scheduleSync(scope = document) {
  if (scheduled) return;
  scheduled = true;

  requestAnimationFrame(() => {
    scheduled = false;
    sync(scope);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => scheduleSync(document), { once: true });
} else {
  scheduleSync(document);
}

document.addEventListener('shopify:section:load', (event) => {
  scheduleSync(event.target instanceof Element ? event.target : document);
});

document.addEventListener('shopify:block:select', (event) => {
  scheduleSync(event.target instanceof Element ? event.target : document);
});

document.addEventListener('shopify:block:deselect', (event) => {
  scheduleSync(event.target instanceof Element ? event.target : document);
});

if (!window.__jpHeroNavigationLabelObserver) {
  const observer = new MutationObserver((mutations) => {
    const affectsHero = mutations.some((mutation) => {
      const target = mutation.target;

      if (target instanceof Element && target.closest(ROOT_SELECTOR)) {
        return true;
      }

      return [...mutation.addedNodes].some((node) => {
        if (!(node instanceof Element)) return false;

        return (
          node.matches(ROOT_SELECTOR) ||
          node.closest(ROOT_SELECTOR) ||
          node.querySelector(ROOT_SELECTOR)
        );
      });
    });

    if (affectsHero) {
      scheduleSync(document);
    }
  });

  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['data-jp-nav-label', 'data-jp-nav-index'],
  });

  window.__jpHeroNavigationLabelObserver = observer;
}